<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-6 searching">
                        <span class="h_page">Program Unggulan</span> <br> <br>
                    </div>
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
                <br>
                <div class="row">

                    <div class="col-md-6">
                        <span class="huruf_input">Periode RPJMD</span>
                        <select class="form-control show-tick" v-model="rpjmd_id" @change="getMisi">
                            <option value="" >-- Semua Periode --</option>
                            <option v-for="data in list_RPJMD" :key="data.rpjmd_id" :value="data.rpjmd_id">{{data.periode}}</option>
                        </select>
                    </div>

                    <div class="col-md-6">
                        <span class="huruf_input">Misi</span>
                        <select class="form-control show-tick" v-model="misi_id" @change="getPersepktif">
                            <option value="" >-- Semua Misi --</option>
                            <option v-for="data in list_misi" :key="data.misi_id" :value="data.misi_id">{{data.uraian}}</option>
                        </select>
                    </div>
                </div>
                <br>
        <!-- ============================================================ MULAI ======================================================================== -->

                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-success kepala_table_f tabel_center">
                            <th class="text-center" style="width: 8%">Kode</th>
                            <th class="text-center" style="width: 50%">Uraian</th>
                            <th class="text-center" style="width: 30%">Keterangan</th>
                            <th class="text-center" style="width: 12%">#</th>
                        </tr>
                        </thead>
                        <tbody class="tabel_center" >
                          <tr class="h_isitable" v-for="data in list_data" :key="data.program_unggulan_id">
                            <td class="tabel_center text-center">{{data.kode}}</td>
                            <td class="tabel_center" >{{data.uraian}}</td>
                            <td class="tabel_center">{{data.keterangan}}</td>
                            <td class="tabel_center text-center" >

                                <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                    <i class="material-icons" >create</i>
                                </button>
                                &nbsp;
                                <button @click="removeData(data.program_unggulan_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                    <i class="material-icons" >clear</i>
                                </button>

                            </td>
                          </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                    <div class="text-center">
                        <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                            <i class="material-icons">skip_previous</i>
                        </button>
                        &nbsp;
                        <span style="font-size: 85%; color: #a5a5a5">
                            <b>{{page_first}} - {{page_last}}</b>
                        </span>
                        &nbsp;
                        <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                            <i class="material-icons">skip_next</i>
                        </button>
                    </div>
                <hr>
                <!-- ============================================================ MODAL ======================================================================== -->


                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-blue">
                                        <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>
                                        <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                    </div>

                                <form @submit.prevent="addData()">

                                    <div class="modal-body">
                                        <div v-if="!check_misi" class="alert alert-info text-center">
                                            <strong>SILAHKAN PILIH PERIODE RPJMD DAN MISI TERLEBIH DAHULU!</strong> 
                                        </div>

                                        <div v-if="check_misi">
                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">No</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="no_program" :required="true" type="number" class="form-control" placeholder="Ex : 1">
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Uraian</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="uraian" :required="true" type="text" class="form-control">
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Keterangan</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                    <div class="form-line">
                                                        <textarea class="form-control" v-model="keterangan"></textarea>
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div class="modal-footer">
                                        <button v-if="check_misi" type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                        <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-green">
                                        <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>
                                        <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                    </div>
                                <form @submit.prevent="editData()">
                                    <div class="modal-body">
                                        <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">No</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="no_program" :required="true" type="number" class="form-control" placeholder="Ex : 1">
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Uraian</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="uraian" :required="true" type="text" class="form-control">
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Keterangan</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                    <div class="form-line">
                                                        <textarea class="form-control" v-model="keterangan"></textarea>
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>



                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                        <button @click="emptyData()"  type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/planning_program_unggulan/';
    const ADD_URL_RPJMD = URL_APP+'api/v1/planning_rpjmd/';
    const ADD_URL_MISI = URL_APP+'api/v1/planning_misi/';
    const ADD_URL_TUJUAN = URL_APP+'api/v1/planning_tujuan/';


    export default {
        name: "planning_rpjmd",
        data() {
            return {

                rpjmd_id : '',
                misi_id : '',
                keterangan : '',
                
                program_unggulan_id: '',
                no_program : '',
                uraian : '',

                check_misi : false,

                list_RPJMD : [],
                list_misi : [],
                list_perspektif : [],

                list_data: [],
                page_first : 1,
                page_last : 0,
                cari_value : ''
            };
        },

        mounted() {
            this.getRPJMD();
            this.getData();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){

                // console.log('RPJMD :'+this.rpjmd_id);
                // console.log('MISI :'+this.misi_id);

                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },

                    body: JSON.stringify({
                        no_program : this.no_program,
                        uraian : this.uraian,
                        keterangan : this.keterangan,
                        misi_id : this.misi_id
                    })


                }).then(res => res.json()).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value,
                      rpjmd_id : this.rpjmd_id,
                      misi_id : this.misi_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_data = res_data.data;
                  this.page_last = res_data.jml_data;
                //   console.log(res_data);
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        program_unggulan_id : this.program_unggulan_id,
                        no_program : this.no_program,
                        uraian : this.uraian,
                        keterangan : this.keterangan,
                        misi_id : this.misi_id
                    })
                }).then((res_data) => {
                //   console.log(res_data);
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
                this.rpjmd_id = data.rpjmd_id;
                this.misi_id = data.misi_id;
                this.keterangan = data.keterangan;
                
                this.program_unggulan_id = data.program_unggulan_id;
                this.no_program = data.no_program;
                this.uraian = data.uraian;

                this.getMisi();
                this.getPersepktif();
                // console.log(data);
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.program_unggulan_id = '';
                this.no_program = '';
                this.uraian = '';
            },

            //TAMBAHAN
            getRPJMD : function(){
                fetch(ADD_URL_RPJMD, {
                    method : 'GET',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    }
                }).then(res => res.json()).then((res_data)=>{
                    this.list_RPJMD = res_data;
                    this.getData();
                    this.page_first = 1;
                    // console.log(res_data);
                })
            },
            getMisi : function(){
                if (this.rpjmd_id == '') { this.misi_id =''} // Agar ketika pilih Periode RPJMD = 'semua periode' maka semua data akan tampil
                fetch(ADD_URL_MISI+'misi_id_rpjmd', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara '+localStorage.token
                    },
                    body : JSON.stringify({
                        rpjmd_id : this.rpjmd_id
                    })
                }).then(res => res.json()).then((res_data)=>{
                    this.list_misi = res_data;
                    this.getData();
                    this.page_first = 1;
                    // console.log(res_data);
                })
            },
            getPersepktif : function(){
                this.page_first = 1;
                this.getData();

                if (this.misi_id == '') {this.check_misi = false; this.getData();} 
                else {this.check_misi = true;}
            },
            //TAMBAHAN

            //PAGINASI
                alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
                },

                btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
                },

                btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
                },

                cari_data : function(){
                this.getData();
                }
            //PAGINASI
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
